/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_EmptyInputs */

const en_us2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sets this week yet. The map lights up as you train.`)
};

const pt_br2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série nesta semana ainda. O mapa acende conforme você treina.`)
};

const es_419_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay series esta semana. El mapa se ilumina a medida que entrenas.`)
};

const pt_pt2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhuma série esta semana. O mapa acende à medida que treinas.`)
};

const fr_fr2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune série cette semaine pour l'instant. La carte s'allume au fil de tes séances.`)
};

const de_de2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Woche noch keine Sätze. Die Karte leuchtet auf, während du trainierst.`)
};

const it_it2_progress_extra_map_empty = /** @type {(inputs: Progress_Extra_Map_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna serie questa settimana. La mappa si illumina man mano che ti alleni.`)
};

/**
* | output |
* | --- |
* | "No sets this week yet. The map lights up as you train." |
*
* @param {Progress_Extra_Map_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_empty = /** @type {((inputs?: Progress_Extra_Map_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_empty(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_empty(inputs)
	return en_us2_progress_extra_map_empty(inputs)
});
export { progress_extra_map_empty as "progress-extra.map_empty" }